(function (app, core) {
    'use strict';

    const TABS_SCROLL_LIMIT = 80;
    const SCROLL_TOP_DELAY = 400;

    app.AuthorListing = function (widget) {
        const _self = this;

        _self.container = widget;
        _self.itemList = _self.container.querySelectorAll('.js-item');
        _self.imageList = _self.container.querySelectorAll('.js-image');
        _self.header = document.querySelector('.main-header');
        _self.setListeners();
    };

    /**
     * Listens for events on Author Listing list
     */
    app.AuthorListing.prototype.setListeners = function () {
        const _self = this;

        const desktopMin = '(min-width: ' + app.breakpoints.desktopMin + 'px)';
        _self.itemList.forEach((item, index) => {
            index === 0 ? core.style.addClass( item, 'isFirst' ) : null;
            if ( window.matchMedia( desktopMin ).matches ) {
                item.addEventListener( 'mouseover', () => {
                    const id = item.dataset.target;
                    _self.imageSwap( id );
                });
            }
        });
    };

    /**
     * Switch image on left-hand side on mouseover based on article ID
     *
     * @param {number} id - article ID
     */
    app.AuthorListing.prototype.imageSwap = function (id) {
        const _self = this;
        let imageId = document.querySelector(`[data-id=image_${id}]`);

        _self.imageList.forEach(function (image) {
            core.style.removeClass(image, 'isVisible');
        });
        imageId ? core.style.addClass(imageId, 'isVisible') : null;
    };

    const widgets = document.querySelectorAll('[data-widget="author-listing"]');
    [].forEach.call(widgets, (widget) => new app.AuthorListing(widget));
})(PULSE.app, PULSE.core);
